import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-black/95 backdrop-blur-md shadow-lg border-b border-gray-900' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <button 
            onClick={() => scrollToSection('hero')}
            className="text-2xl font-bold text-white cursor-pointer hover:text-red-500 transition-colors"
            style={{ fontFamily: '"Pacifico", serif' }}
          >
            Another Piercing Co
          </button>

          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-white hover:text-red-500 transition-colors font-medium cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('artists')}
              className="text-white hover:text-red-500 transition-colors font-medium cursor-pointer"
            >
              Our Artists
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-red-500 transition-colors font-medium cursor-pointer"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-white hover:text-red-500 transition-colors font-medium cursor-pointer"
            >
              Contact
            </button>
            <a 
              href="tel:3163057076"
              className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors font-bold cursor-pointer whitespace-nowrap"
            >
              Call Now
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-md border-t border-gray-900">
          <div className="px-4 py-6 space-y-4">
            <button 
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-white hover:text-red-500 transition-colors font-medium cursor-pointer py-2"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('artists')}
              className="block w-full text-left text-white hover:text-red-500 transition-colors font-medium cursor-pointer py-2"
            >
              Our Artists
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-white hover:text-red-500 transition-colors font-medium cursor-pointer py-2"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-white hover:text-red-500 transition-colors font-medium cursor-pointer py-2"
            >
              Contact
            </button>
            <a 
              href="tel:3163057076"
              className="block bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors font-bold cursor-pointer text-center"
            >
              Call Now
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
